module.exports = __webpack_public_path__ + "img/completed_pickup.08c65300.svg";